import { useMemo } from 'react'
import { AtSign, Image } from 'lucide-react'
import type { AdminColumn } from '@/components/DataTable/types'
import { ModListScreen } from './ModListScreen'
import { makeFetcher, MOD_STR as S, type UsernameModRow, type AvatarModRow } from './modContentApi'

/**
 * A6.11 — Username moderatsiyasi (spoofing). Impersonatsiya / o'xshash username
 * navbati (GET /admin/moderation/usernames).
 */
export function UsernameModerationScreen() {
  const columns = useMemo<AdminColumn<UsernameModRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'username', header: S.username, type: 'text' },
      { key: 'user_id', header: S.targetId, type: 'number' },
      { key: 'similar_to', header: S.similarTo, type: 'text' },
      { key: 'kind', header: S.kind, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<UsernameModRow>
      screenId="A6.11"
      title={S.usernames}
      description={S.usernamesDesc}
      columns={columns}
      fetcher={makeFetcher<UsernameModRow>(
        '/admin/moderation/usernames',
        'items',
        (r) => `${r.username} ${r.similar_to} ${r.kind}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<AtSign size={28} strokeWidth={1.5} />}
    />
  )
}

/**
 * A6.12 — Avatar / rasm moderatsiyasi. Profil rasmlari va avatarlarni ko'rib
 * chiqish navbati (GET /admin/moderation/avatars).
 */
export function AvatarModerationScreen() {
  const columns = useMemo<AdminColumn<AvatarModRow>[]>(
    () => [
      { key: 'id', header: 'ID', type: 'id' },
      { key: 'user_id', header: S.targetId, type: 'number' },
      { key: 'entity', header: S.entity, type: 'text' },
      { key: 'category', header: S.category, type: 'text' },
      { key: 'status', header: S.status, type: 'text' },
      { key: 'created_at', header: S.created, type: 'date' },
    ],
    [],
  )
  return (
    <ModListScreen<AvatarModRow>
      screenId="A6.12"
      title={S.avatars}
      description={S.avatarsDesc}
      columns={columns}
      fetcher={makeFetcher<AvatarModRow>(
        '/admin/moderation/avatars',
        'items',
        (r) => `${r.entity} ${r.category}`,
      )}
      rowId={(r) => String(r.id)}
      icon={<Image size={28} strokeWidth={1.5} />}
    />
  )
}
